// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1fk2N","consentsList":"PatientConsents_consentsList__3xOjQ","consentsListEmpty":"PatientConsents_consentsListEmpty__1Yyoa"};